import React from 'react';
import Icon from '../../components/Icon';
import './TransportChip.css';

/**
 * F13.1 — small inline chip that shows which transport carried a transfer.
 *
 * Used inside FileCard (F11.2) and CodeBubble footers (F12.1) so a recipient
 * can see, after the fact, whether a payload came over LAN or Cloud.
 *
 * Props:
 *  - `via`   — `'lan' | 'cloud'`, drives the colorway + icon.
 *  - `label` — text shown next to the icon. Defaults to "LAN" / "Cloud".
 *  - `size`  — `'sm' | 'md'`. `'sm'` matches the dense 18px style used in
 *              bubble footers; `'md'` matches the 22px default from the
 *              shared stylesheet. Defaults to `'sm'` because every usage
 *              today is in a dense surface.
 */
const TransportChip = ({ via, label, size = 'sm' }) => {
  if (via !== 'lan' && via !== 'cloud') return null;

  const text = label ?? (via === 'lan' ? 'LAN' : 'Cloud');
  const iconColor = via === 'lan' ? '#b6ffd6' : '#ffd9a8';
  const iconSize = size === 'sm' ? 10 : 12;
  const className = `t-chip ${via}${size === 'sm' ? ' size-sm' : ''}`;

  return (
    <span className={className}>
      <Icon
        name={via === 'lan' ? 'wifi' : 'cloud'}
        size={iconSize}
        stroke={iconColor}
      />
      {text}
    </span>
  );
};

export default TransportChip;
